<template>
  <div class="top-content">
    <div class="left">
      <el-button-group>
        <el-button @click="prevClick" type="primary" icon="el-icon-arrow-left"></el-button>
        <el-button @click="nextClick" type="primary">
          <el-icon class="el-icon--right">
            <ArrowRight/>
          </el-icon>
        </el-button>
      </el-button-group>
      <el-button @click="todayClick" type="primary" plain style="margin-left: 20px">今天</el-button>
      <el-radio-group v-model="viewType" @change="changeViewTypeFn" style="margin-left: 20px">
        <el-radio-button label="dayGridMonth">月视图</el-radio-button>
        <el-radio-button label="timeGridWeek">周视图</el-radio-button>
      </el-radio-group>
    </div>
    <div class="center">
      <h2>{{ title }}</h2>
    </div>
    <div class="right">
      <el-select v-model="formData.user_id" placeholder="人员" class="toolbar_item" style="width: 130px"
                 @change="scheduleQuery">
        <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" @click="scheduleQuery" class="toolbar_item">查询</el-button>
      <el-button type="primary" @click="isExport" class="toolbar_item">导出</el-button>
    </div>
  </div>


  <div class="calendar_box">
    <div class="event-info">
      <div class="tags">
        <span class="level level-1"></span>
        <span class="label">出差</span>
      </div>
      <div class="tags">
        <span class="level level-2"></span>
        <span class="label">出勤</span>
      </div>
      <div class="tags">
        <span class="level level-3"></span>
        <span class="label">外出/休假</span>
      </div>
      <div class="tags">
        <span class="level level-4"></span>
        <span class="label">提醒</span>
      </div>
      <div class="tags">
        <span class="level level-6"></span>
        <span class="label">加班</span>
      </div>

      <div class="tags">
        <span class="level level-5"></span>
        <span class="label">法定节假日</span>
      </div>
    </div>
    <el-scrollbar>
      <FullCalendar
          class='demo-app-calendar'
          :options='calendarOptions'
          :onselect="onDateSelect"
          ref="fullCalendar"
          v-contextmenu:contextmenu
      >
        <template v-slot:eventContent='arg'>
          <div :class="arg.event.extendedProps.type">
            <span>{{ arg.event.extendedProps.content }}</span>
            <span style="float: right;margin-left: 10px;">{{ arg.event.extendedProps.range_time }}</span>
          </div>
        </template>
      </FullCalendar>
    </el-scrollbar>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="addSchedule('')">添加日程</v-contextmenu-item>
      <v-contextmenu-item @click="addSchedule('schedule_remind')">添加提醒</v-contextmenu-item>
    </v-contextmenu>

    <div style="margin-top: 5px;margin-left: 10px">
      *点击日程可查看详情
    </div>

    <!--添加日程dialog -->
    <el-dialog title="日程安排" :model="formData" v-model="dialogFormVisible" style="width: 700px">
      <el-form label-width="150px" :rules="rules">
        <el-form-item label="开始日期：" prop="star">
          <el-date-picker
              v-model="formData.schedule_date"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="请选择日期"
              style="width: 250px"
              :disabled-date="disableStartDate"
          />
        </el-form-item>

        <el-form-item label="开始时间：" v-if="formData.type != 'schedule_remind'">
          <el-time-select
              v-model="formData.start_time"
              start="05:00"
              step="00:30"
              end="22:00"
              placeholder="请选择时间"
              style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="结束时间：" v-if="formData.type != 'schedule_remind'">
          <el-time-select
              v-model="formData.end_time"
              start="05:00"
              step="00:30"
              end="22:00"
              placeholder="请选择时间"
              style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="提醒时间：" v-if="formData.type == 'schedule_remind'">
          <el-time-select
              v-model="formData.remind_time"
              start="06:00"
              step="00:10"
              end="24:00"
              placeholder="提醒时间"
              style="width: 250px"
          />
        </el-form-item>

        <el-form-item label="类型：" prop="star">
          <el-select v-model="formData.type" style="width: 250px" clearable>
            <el-option v-for="dict in scheduleType" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="内容：" prop="star">
          <el-input type="textarea" v-model="formData.content" style="width: 400px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <!--导出日程dialog -->
    <el-dialog title="日程导出" :model="form" v-model="dialogFormExport" style="width:700px">
      <FrameForm componentParam="schedule_export" :init-data="formData"/>
    </el-dialog>


    <!--日程详情dialog -->
    <el-dialog title="日程详情" :model="form" v-model="dialogForm" style="width: 600px">
      <el-form label-width="0px">
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.schedule_date }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ form.user_name }} - {{ form.type }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px">{{ "跟进时间：" + form.start_time }} - {{
              form.end_time
            }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18" style="margin-top: 10px;white-space: pre-wrap;">{{ form.content }}</el-col>
        </el-row>
        <el-form-item>
          <el-button @click="deleteSchedule" style="margin-top: 10px;" :loading="loading">删除日程</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import {ArrowRight} from "@element-plus/icons-vue";

export default {
  name: "ScheduleManage",
  components: {
    ArrowRight,
    FullCalendar,
  },
  data() {
    return {
      holidays: [],
      title: '',
      viewType: 'timeGridWeek',
      activeName: 'first',
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
      // scheduleType: [],
      // scheduleState: [],
      userList: [],
      dialogForm: false,
      dialogFormVisible: false,
      dialogFormExport: false,
      users: [],
      params: {},
      viewVisible: false,
      selectId: 0,
      selectDate: '',
      saveVisible: false,
      queryListEventMap: {
        button_id: '',
        query_id: '',
        start_date: ''
      },
      formExport: {
        user_id: '',
        export_start_time: '',
        export_end_time: ''
      },
      form: {
        id: '',
        user_id: '',
        user_name: '',
        title: '',
        type: '',
        comments: '',
        result: '',
        start_time: '',
        end_time: '',
        remark: '',
        commentsList: []
      },
      formData: {
        schedule_end_date: '',
        schedule_date: '',
        user_id: '',
        content: '',
        type: '',
        result: '',
        start_time: '',
        end_time: '',
        remind_time: ''
      },
      calendarOptions: {
        eventLimit: false,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        allDaySlot: false,
        locale: "zh-cn",
        fixedWeekCount: false,
        eventDurationEditable: true, // 允许事件持续时间可编辑
        initialView: "timeGridWeek",
        headerToolbar: false,
        events: [],
        firstDay: 1,
        contentHeight: 'auto',
        editable: false,
        selectable: true,
        // selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick,
        select: this.onDateSelect,
        viewDidMount: this.onViewChange,
        slotMinTime: "06:00:00",
        views: {
          timeGridWeek: {
            type: 'timeGridWeek',
          },
          dayGridMonth: {
            type: 'dayGridMonth'
          }
        },
      },

      currentEvents: [],
      eventGuid: 0,
    };
  },
  computed: {
    scheduleType() {
      return this.$store.getters['core/getDictList']('schedule_type');
    },
    scheduleResult() {
      return this.$store.getters['core/getDictList']('schedule_result');
    }
  },
  created() {
    this.fullName();
    this.scheduleQuery()
    this.getUserList()
  },
  methods: {
    // 禁用开始日期的逻辑
    disableStartDate(date) {
      if (!this.formData.schedule_end_date) return false;
      const endDate = new Date(this.formData.schedule_end_date);
      return date > endDate;
    },
    //获取标题以及获取当前页面是否有节假日
    getCalendarTitle() {
      // 获取 FullCalendar 实例
      const calendarApi = this.$refs.fullCalendar.getApi()

      // 获取当前视图
      const currentView = calendarApi.view;

      // 获取当前视图的标题
      this.title = currentView.title;
      const startDate = currentView.currentStart
      const endDate = currentView.currentEnd
      this.getLegalHolidays(startDate, endDate, calendarApi)

    },
    async getLegalHolidays(starDate, endDate, calendarApi) {
      let params = {
        start_date: starDate.format('yyyy-MM-dd'),
        end_date: endDate.format('yyyy-MM-dd')
      }
      await this.$http('oaScheduleService.getLegalHolidays', params).then(data => {
        this.holidays = data || []
        const holidayEvents = this.holidays.map(date => ({
          start: date,
          end: date,
          display: 'background',
          color: '#d6a0d3'
        }));

        calendarApi.addEventSource(holidayEvents);
      })
    },
    changeViewTypeFn(type) {
      this.$refs.fullCalendar.getApi().changeView(type)
      this.getCalendarTitle()
    },
    windowResize() {
      this.$refs.fullCalendar.getApi().updateSize()
    },
    nextClick() {
      this.$refs.fullCalendar.getApi().next()
      this.scheduleQuery()
      this.getCalendarTitle()
    },

    prevClick() {
      this.$refs.fullCalendar.getApi().prev()
      this.scheduleQuery()
      this.getCalendarTitle()
    },

    todayClick() {
      this.$refs.fullCalendar.getApi().today()
      this.scheduleQuery()
      this.getCalendarTitle()
    },

    clearData() {
      this.formData.schedule_date = ''
      this.formData.schedule_end_date = ''
      this.formData.schedule_range = ''
      this.formData.content = ''
      this.formData.type = ''
      this.formData.result = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.form.user_id = ''
      this.form.title = ''
      this.form.comments = ''
      this.form.type = ''
      this.form.result = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form.remark = ''
      this.dialogFormVisible = false;
    },

    fullName() {
      this.formData.user_id = this.$store.state.core.currentUser?.id
    },

    //添加日程
    submit() {
      if (!this.formData.schedule_date) {
        return this.$message.error('请选择日期')
      }
      if (!this.formData.content) {
        return this.$message.error('请输入内容')
      }
      if (!this.formData.type) {
        return this.$message.error('请选择类型')
      }

      this.$http('oaScheduleService.addSchedule', this.formData).then(() => {
        this.scheduleQuery()
        this.clearData()
      })
    },

    //添加批注
    addScheduleComments() {
      if (!this.form.comments) {
        return this.$message.error('请输入批注')
      }

      this.$http('oaScheduleService.addComments', this.form).then(() => {
        this.dialogForm = false;
        this.scheduleQuery()
        this.clearData()
      })
    },

    //添加反馈
    updateSchedule() {
      if (!this.form.result) {
        return this.$message.error('请选择执行结果')
      }

      this.$http('oaScheduleService.updateScheduleResult', this.form).then(() => {
        this.dialogForm = false;
        this.scheduleQuery()
        this.clearData()
      })

    },

    //删除日程
    deleteSchedule() {
      this.$http('oaScheduleService.deleteById', this.form).then(() => {
        this.dialogForm = false;
        this.scheduleQuery()
        this.clearData()
      })
    },

    addSchedule(type) {
      if ("schedule_remind" == type) {
        this.formData.type = "schedule_remind"
      } else {
        this.formData.type = ""
      }
      this.dialogFormVisible = true;
    },

    isExport() {
      this.dialogFormExport = true;
    },
    onDateSelect(selectionInfo) {
      console.log(selectionInfo)
      if (!selectionInfo) {
        return
      }

      this.formData.schedule_date = selectionInfo.start.format("yyyy-MM-dd");
      this.formData.start_time = selectionInfo.start.format("hh:mm");
      this.formData.remind_time = selectionInfo.start.format("hh:mm");
      this.formData.end_time = selectionInfo.end.format("hh:mm");
    },


    //查询日程
    async scheduleQuery() {
      if (!this.formData.user_id) {
        return
      }
      this.calendarOptions.events = await this.$http('oaScheduleService.getUserSchedule', this.formData)
      this.getCalendarTitle()
    },

    //查询详情
    async handleEventClick(clickInfo) {
      this.clearData()
      this.dialogForm = true;

      let params = {id: clickInfo.event.id}
      this.form = await this.$http('oaScheduleService.getScheduleDetails', params)
    },

    async getUserList() {
      this.userList = await this.$http('sysDsService.getSubUsers')
    }
  },

}

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

</script>

<style>
/* 去掉控件里的边框，背景色*/
.fc .fc-v-event {
  background-color: white !important;
  border: none !important;
}

.fc .fc-timegrid-event {
  box-shadow: none !important;
}

.fc .fc-highlight {
  background: rgba(188, 232, 241, .7) !important;
}

.fc .fc-event-main {
  padding: 1px 0px 1px !important;
}

.fc th {
  position: sticky;
  background: white;
  top: 0;
  z-index: 10;
  text-align: center;
}
</style>

<style lang="less" scoped>

.calendar_box {
  width: 100%;
  height: 80%;
  padding: 20px;

  .event-info {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .tags {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .level {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 5px;

        &.level-1 {
          background-color: burlywood;
        }

        &.level-2 {
          background-color: lightgreen;
        }

        &.level-3 {
          background-color: lightcoral;
        }

        &.level-4 {
          background-color: #6699CC;
        }

        &.level-5 {
          background-color: #d6a0d3;
        }

        &.level-6 {
          background-color: #2a2a2a;
        }
      }
    }
  }
}

.my_toolbar {
  position: absolute;
  top: 25px;
  left: 200px;
  text-align: left;
  line-height: 40px;
  vertical-align: middle;
  /*border: 1px dotted lightgray;*/
  display: inline-flex;

}

.toolbar_item {
  margin-right: 10px;
}

.schedule_business_trip {
  background-color: burlywood;
  border-left: 4px solid orange;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_overtime {
  background-color: #2a2a2a; /* 黑灰色背景 */
  border-left: 4px solid #555; /* 深灰色边框 */
  color: #ffffff; /* 浅灰色文字 */
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_normal {
  background-color: lightgreen;
  border-left: 4px solid #42b983;
  color: #0a84ff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_leave {
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_out {
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_remind {
  background-color: #6699CC;
  border-left: 4px solid #1a70ff;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scheduleDetail {
  font-size: 16px;
}

.top-content {
  display: flex;
  align-items: center;
  padding: 20px;
  box-shadow: 0 0 10px #eee;

  .left {
    display: flex;
    align-items: center;
    margin-right: 30px;
    line-height: 24px;
    font-weight: bold;

    .el-button {
      margin: 0; /* 移除外边距 */
    }

    .op {
      cursor: pointer;
      font-size: 18px;
      padding: 0 10px;
      line-height: 24px;

      &:hover {
        color: #3e3bee;
      }
    }
  }

  .center {
    flex: 1;
    text-align: center;

    .el-input {
      width: 300px;
    }
  }

  .today-btn {
    margin-right: 20px;
  }
}
</style>